module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2p"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("PART I"), _c('br'), _c('br'), _vm._v("Infancy")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('strong', [_vm._v("Antecedents of the Big Four can be found in surprising places – including late-medieval Florence. The modern history of the firms contains remarkable echoes of the pre-modern and early-modern history of the Medici Bank. How that bank was structured and staffed – and how its staff worked and lived – would be repeated centuries later in curious ways. We therefore explore in this part the Medici Bank as a Big Four antecedent; in later chapters we trace some of the echoes, before returning to the Medici Bank in detail in ")])]), _c('strong', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")]), _vm._v(" to understand possible Big Four endgames.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("The foundations of the Big Four were also laid in early financial scandals, during the Industrial Revolution but particularly amid the rapid development of Britain’s railways in the nineteenth century. We examine those foundations in this part, along with the firms’ key founders, and the beliefs and convictions that guided how they worked.")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2b3892","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01.vue
// module id = 78
// module chunks = 0